import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthApiService } from 'src/app/services/auth-api.service';
import { SettingsService } from 'src/app/services/settings.service';
import { AuthResponse } from 'src/app/shared/models/users/auth-response';
import { SignIn } from 'src/app/shared/models/users/sign-in';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { Error } from 'src/app/shared/models/general/error';
import { OtpUser } from 'src/app/shared/models/otp/otp-user';
import { NgForm } from '@angular/forms';
import { getEmailRegExpression } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  reCaptchaKey = environment.reCaptchaKey;
  busy: boolean = false;
  otpBusy: boolean = false;
  errorMsg: string = 'Incorrect Username or Password';
  showError: boolean = false;
  showPasswordField: boolean = true;
  showOtpField: boolean = true;
  showOtpVerification: boolean = false;

  regexForEmail = getEmailRegExpression();

  signIn: SignIn = new SignIn();
  otpUser: OtpUser = {
    userId: 0,
    otp: '',
  };

  constructor(
    private router: Router,
    private authApi: AuthApiService,
    public settingsService: SettingsService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {}

  ngOnInit(): void {}

  public async SignIn(signInForm: NgForm) {
    if (signInForm.invalid) {
      signInForm.form.markAllAsTouched();
      return;
    }
    this.busy = true;
    this.errorMsg = '';
    this.showError = false;
    this.recaptchaV3Service.execute('Login').subscribe((token) => {
      this.authApi
        .login(this.signIn)
        .toPromise()
        .then(
          (uId: number) => {
            this.showOtpVerification = true;
            this.otpUser.userId = uId;
            this.busy = false;
          },
          (error) => {
            this.showError = true;
            this.errorMsg = Error.InterpretErrorMessage(error);
            this.busy = false;
          }
        );
    });
  }

  public async VerifyOtp(otpForm: NgForm) {
    if (otpForm.invalid) {
      otpForm.form.markAllAsTouched();
      return;
    }
    this.errorMsg = '';
    this.showError = false;
    this.otpBusy = true;
    this.authApi.validateOtp(this.otpUser).subscribe({
      next: (authResponse: AuthResponse) => {
        localStorage.setItem('token', authResponse.accessToken);
        localStorage.setItem('tokenExpires', String(authResponse.expiresAt));
        localStorage.setItem('userId', this.otpUser.userId.toString());
        this.settingsService.GetUserDetails(this.otpUser.userId).then(() => {
          this.otpBusy = false;
          this.router.navigate(['user-management']);
        });
      },
      error: (error) => {
        this.showError = true;
        this.errorMsg = Error.InterpretErrorMessage(error);
        this.otpBusy = false;
      },
    });
  }

  showPassword() {
    this.showPasswordField = !this.showPasswordField;
  }
}
